class AuthenticateTokenController {
    /*@ngInject*/
    constructor($timeout, authService, MESSAGECONSTANTS) {
        this.$timeout = $timeout;
        this.authService = authService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    $onInit() {
        //variables
        this.tokenObject = {};
        this.tokenObject.token = this.token;
        this.tokenObject.email = this.email;
        if (this.companyId) {
            this.tokenObject.companyId = this.companyId;
        }
        //flags
        this.loadingFlag = true;
        this.$timeout(() => {
            if (this.email !== undefined) {
                this.authenticateToken();
            }
        }, 500);
    }
    authenticateToken() {
        if (!this.authenticateForm.$invalid) {
            this.authService.authenticateToken(this.tokenObject, (data) => {
                if (this.successCallback) {
                    this.successCallback({ tokenResponse: data });
                }
            }, (error) => {
                if (this.errorCallback) {
                    this.errorCallback({ tokenResponse: error });
                }
            });
        }
    }
}
AuthenticateTokenController.$inject = ['$timeout', 'authService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './authenticate-token.html';
import * as TEMPLATE from 'raw-loader!./authenticate-token.html';
export const AuthenticateTokenComponent = {
    selector: 'authenticateToken',
    component: {
        bindings: {
            token: '@',
            email: '@',
            companyId: '@',
            successCallback: '&',
            errorCallback: '&'
        },
        controller: AuthenticateTokenController,
        // templateUrl: 'app/partials/tokenLogin/authenticateToken/authenticate-token.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=authenticate-token.component.js.map